import { DatePipe } from '@angular/common';
import { Component, model, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpService } from 'src/app/service/http/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { EmployeeMasterComponent } from '../employee-master/employee-master.component';
import { HomeCompetencySetStatusPopupComponent } from 'src/app/shared/popups/home-competency-set-status-popup/home-competency-set-status-popup.component';
import { HomeAddNewSocialFieldPopupComponent } from 'src/app/shared/popups/home-add-new-social-field-popup/home-add-new-social-field-popup.component';
import { HomeCreateAnnouncementPopupComponent } from 'src/app/shared/popups/home-create-announcement-popup/home-create-announcement-popup.component';
import { HomeEmployeeMasterPopupComponent } from 'src/app/shared/popups/home-employee-master-popup/home-employee-master-popup.component';
import { HomeQuickSearchPopupComponent } from 'src/app/shared/popups/home-quick-search-popup/home-quick-search-popup.component';
import { CompetecnyDashboardDetailsPopupComponent } from 'src/app/shared/popups/competecny-dashboard-details-popup/competecny-dashboard-details-popup.component';
import { DashboardDetailsPopupComponent } from 'src/app/shared/popups/dashboard-details-popup/dashboard-details-popup.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { HomeWelcomeNewEmployeePopupComponent } from 'src/app/shared/popups/home-welcome-new-employee-popup/home-welcome-new-employee-popup.component';
import { ViewemployeedetailsComponent } from 'src/app/viewemployeedetails/viewemployeedetails.component';
import { SharedService } from 'src/app/service/shared/shared.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ElcmCreateEmailTempletComponent } from '../ELCM/elcm-create-email-templet/elcm-create-email-templet.component';
import { AddEditCandidatePopupComponent } from '../recruitment/add-edit-candidate-popup/add-edit-candidate-popup.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { PositionrequisitionformComponent } from '../recruitment/positionrequisitionform/positionrequisitionform.component';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { GenericServiceService } from 'src/app/services/generic-service.service';
import { LatLongService } from 'src/app/services/lat-long/lat-long.service';
import { AppUpdateServiceService } from 'src/app/services/app-update/app-update-service.service';
import { ToastrService } from 'ngx-toastr';

interface Employee {
  id: number;
  name: string;
  designation: string;
  contactNo: string;
  officialEmail: string;
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-hr-admin-my-home',
  templateUrl: './hr-admin-my-home.component.html',
  styleUrls: ['./hr-admin-my-home.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }]
})
export class HrAdminMyHomeComponent implements OnInit {
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any;
  FiscalYear: any;
  fromYear: any;
  toYear: any;
  buttonColorName: any;
  loggedInUserRole: any;
  loggedInCompanyMDID: any;
  loggedInCompanyHRID: any;
  setupGradeBrand: any;
  activeNo: any;
  exitedNo: any;
  countOfActiveEmployee: any;
  countOfExitedEmployee: any;
  countOfGoalSetting: any;
  countOfReviewStatus: any;
  countOfManagerApprovalStatus: any;
  // BirthdaysMarriageAnniversariesTotalEmp: any
  // WorkAnniversariesTotalEmp: any

  pendingSetups!: { componentName: string; componentKey: string; setupCompleted: boolean; isRegistered: boolean }[][];

  isIncrementSetupDone: any;
  isVPSetupDone: any;
  currentTabName: any;
  // getBirthdaysAndAnniversariesYesterDayData: any = [];
  // getBirthdaysAndAnniversariesToDayData: any = [];
  // getBirthdaysAndAnniversariesNextDayData: any = [];
  // getWorkAnniversariesByYesterdayDateData: any = [];
  // getWorkAnniversariesByToDayDateData: any = [];
  // getWorkAnniversariesByTommorrowDateData: any = [];
  selectedEmployeeDashboardId: any;
  employeelistUnderManager: any = [];
  // getAddNewEmployeeTotalEmp: any
  // getAddNewEmployeeData: any = [];
  dailyTeamTaskFromDate: any;

  CareerProfessionalInfoSearch: any;

  taskAssignedToMeFromDate: any;
  taskAssignedToMeToDate: any;

  getEmployeeByIdData: any = {};

  selected = model<Date | null>(null);
  dailyWorkManagementDate: any;
  incrementBudgetPercentage: any;
  incrementBudgetAmount: any;
  vpBudgetPercentage: any;
  vpBudgetAmount: any;
  socialFeedCount: any;
  howAreYouFellingToDate: Date = new Date();
  howAreYouFellingTodayDate: any;

  getUserExcellentFelling: any = 0;
  getUserGreatFelling: any = 0;
  getUserOkayFelling: any = 0;
  getUserNotGreatFelling: any = 0;

  getMonthsByFiscalandReviewCycle: any;
  selectedYearReviewCycle: any;
  fromDate: any;
  toDate: any;
  selectedReviewCycle: any = [];
  getMonthsByFiscalandReviewCycleForReport: any = [];
  getAnnouncementTableData: any = [];

  vpFrequency: any = [];
  isPMSModuleAvailable: any = false;
  isCompetencyModuleAvailable: any = false;
  isTaskManagementModuleAvailable: any = false;
  isIncrementModuleAvailable: any = false;
  isVariablePayModuleAvailable: any = false;
  // modelWidthForMobileDevice!:string;
  toggleBirthdayAnniversary: boolean = false;
  toggleAnniversary: boolean = false;
  isPayrollEnabled: boolean = false;

  constructor(
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private httpService: HttpService,
    private config: Config,
    private encryptionService: EncryptionService,
    public router: Router,
    public sharedService: SharedService,
    private route: ActivatedRoute,
    public mobileResponsiveService: MobileResponsiveService,
    private latLongService: LatLongService,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService,
    private genericServiceService: GenericServiceService,
    public appUpdateServiceService: AppUpdateServiceService,
    public toastr: ToastrService
  ) {}

  selectedTab: string = 'getPersonalDetailsTab';
  selectedNewEmpTab: string = 'CurrentMonthTab';
  selectedBMACelebrationTab: string = 'toDay';
  selectedWACelebrationTab: string = 'Today';
  selectLeaveAndAttendanceTab: string = 'TodaysAbsentees';
  selecttaskManagementTab: string = 'Review Meeting';
  sidebarModules: any = [];
  socialFeedCardData: any = [];
  // newEmployeeData: any = [
  //   { name: 'Mr. Sample Name', post: 'Date analyst' },
  //   { name: 'Mr. Sample Name', post: 'Date analyst' },
  //   { name: 'Mr. Sample Name', post: 'Date analyst' },
  // ]

  ngOnInit() {
    this.genericServiceService.isPayrollEnabled.subscribe({
      next: (value: boolean) => {
        this.isPayrollEnabled = value;
      }
    });

    this.route.url.subscribe(urlSegments => {
      this.currentTabName = urlSegments.join('/');
      console.log('Active Tab:', this.currentTabName);
    });
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if (sessionStorage.getItem('loggedInCompanyMDID')) {
      this.loggedInCompanyMDID = this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID'));
    }
    this.loggedInCompanyHRID = sessionStorage.getItem('userCompanyHr');

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.FiscalYear = `${currentYear}-${currentYear}`;
    } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
      this.FiscalYear = currentMonth < 3 ? `${currentYear - 1}-${currentYear}` : `${currentYear}-${currentYear + 1}`;
    } else if (this.loggedInCompanyFiscalyear === 'July_Jun') {
      this.FiscalYear = currentMonth < 6 ? `${currentYear - 1}-${currentYear}` : `${currentYear}-${currentYear + 1}`;
    } else if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
      this.FiscalYear = currentMonth < 9 ? `${currentYear - 1}-${currentYear}` : `${currentYear}-${currentYear + 1}`;
    }

    // FiscalYear
    var test = this.FiscalYear.split('-');
    this.fromYear = test[0];
    this.toYear = test[1];

    const currentDate = new Date();
    this.howAreYouFellingTodayDate = currentDate;
    this.dailyTeamTaskFromDate = currentDate;
    this.dailyWorkManagementDate = currentDate;

    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    this.taskAssignedToMeFromDate = firstDay;
    this.taskAssignedToMeToDate = lastDay;

    const today = new Date();
    this.currentYear = today.getFullYear();
    this.currentMonth = today.getMonth();

    this.generateCalendar();
    this.getSidebarModules();
    // this.getWishes();
    // this.getWishesForWorkAnniversery()

    this.fetchPositions();
  }

  ionViewWillEnter() {
    this.getManagerDashboardData();
    // this.getCompetencySetup();
    this.getEmployeeCount();
    // this.getDashboardCountV1();
    // this.getEmployeeById()
    // this.showNewEmpContent(this.selectedNewEmpTab)
    // this.showBMAcelebrationContent(this.selectedBMACelebrationTab);
    // this.showWAcelebrationContent(this.selectedWACelebrationTab)
    this.getAllWishesByDate(0);
    this.getGlobalSummary();
    // this.onCheckPendingSetups();
    this.onCheckPendingSetupsAndEmpDetails();

    this.taskManagementContent(this.selecttaskManagementTab);
    this.getAnnouncementAndSocialFeedData();
    this.getWishes();
    this.getWishesForWorkAnniversery();
    // this.getHowAreYouFellingTodayData();
  }

  getCompetencySetup() {
    this.httpService.callGetService(this.config.getCompetencySetupById + this.loggedInUserCompanyID + '/' + this.FiscalYear).subscribe((response: any) => {
      const getCompetencySetup = response?.data;

      if (getCompetencySetup) {
        this.setupGradeBrand = getCompetencySetup.selectcompetency;
      }
    });
  }

  getSidebarModules() {
    setTimeout(() => {
      this.sidebarModules = JSON.parse(sessionStorage.getItem('sidebarNames') || '[]');
      this.isPMSModuleAvailable = this.sidebarModules.some((module: any) => module.moduleName === 'PMS');
      this.isCompetencyModuleAvailable = this.sidebarModules.some((module: any) => module.moduleName === 'Competency');
      this.isTaskManagementModuleAvailable = this.sidebarModules.some((module: any) => module.moduleName === 'Task Mgt');
      this.isIncrementModuleAvailable = this.sidebarModules.some((module: any) => module.moduleName === 'Increment');
      this.isVariablePayModuleAvailable = this.sidebarModules.some((module: any) => module.moduleName === 'Variable Pay');
    }, 3000);
  }
  // getMonths() {
  //   const request = {
  //     companyId: this.loggedInUserCompanyID,
  //     fromYear: this.fromYear,
  //     toYear: this.toYear
  //   }
  //   this.httpService.callPostService(this.config.getMonths, request).subscribe((data: any) => {
  //     this.selectedReviewCycle = [];
  //     this.getMonthsByFiscalandReviewCycleForReport = []
  //     this.getMonthsByFiscalandReviewCycle = data.data?.months;
  //     data.data?.months?.forEach((ele: any) => {
  //       let obj = {
  //         id: ele,
  //         name: this.sharedService.transform(ele)
  //       }
  //       this.getMonthsByFiscalandReviewCycleForReport.push(obj)
  //     });
  //     this.selectedYearReviewCycle = data.data?.reviewCycle;
  //     const currentMonthIndex = new Date().getMonth();
  //     let selectedIndex = 0;
  //     const today = new Date();
  //     const month = today.toLocaleString('default', { month: 'long' });
  //     if (this.selectedYearReviewCycle == 'Monthly') {
  //       this.getMonthsByFiscalandReviewCycle.forEach((ele: any) => {
  //         var checkMonth = ele?.split('-');
  //         if (month == checkMonth[0]) {
  //           this.fromDate = ele;
  //           this.toDate = ele;
  //           this.selectedReviewCycle.push({ id: ele, name: this.sharedService.transform(ele) });
  //         }
  //       });
  //     }

  //     if (this.selectedYearReviewCycle == 'Quarterly' || this.selectedYearReviewCycle == 'Semi_Annually'
  //       || this.selectedYearReviewCycle == 'Annually'
  //     ) {
  //       for (let range of this.getMonthsByFiscalandReviewCycle) {
  //         const [start, end] = range?.split('-');
  //         const startMonthIndex = this.getMonthIndex(start);
  //         const endMonthIndex = this.getMonthIndex(end);

  //         if (
  //           (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
  //           (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
  //         ) {
  //           this.fromDate = range;
  //           this.toDate = range;
  //           this.selectedReviewCycle.push({ id: range, name: this.sharedService.transform(range) });
  //         }
  //       }
  //     }

  //     // this.getDashboardCount();
  //     this.getDashboardCountV1();
  //     // this.getEmployeeMasterCount();
  //   })
  // }

  getMonthIndex(monthName: string): number {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }

  // Employee Master

  getEmployeeCount() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.getEmployeeCount, request).subscribe((data: any) => {
      this.activeNo = data.data.activeNo;
      this.exitedNo = data.data.exitedNo;
    });
  }

  // PMS

  getDashboardCount() {
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HR Admin') {
      id = this.loggedInCompanyHRID;
    } else {
      id = this.loggedInUserId;
    }
    let request = {};
    if (id === 'null') {
      request = {
        companyId: this.loggedInUserCompanyID,
        month: this.fromDate,
        userId: this.loggedInCompanyMDID,
        year: this.FiscalYear,
        loggedInUserRole: this.loggedInUserRole
      };
    } else {
      request = {
        companyId: this.loggedInUserCompanyID,
        month: this.fromDate,
        userId: id,
        year: this.FiscalYear,
        loggedInUserRole: this.loggedInUserRole
      };
    }

    this.httpService.callPostService(this.config.dashboardCount, request).subscribe((data: any) => {
      this.countOfGoalSetting = data.countOfGoalSetting;
      this.countOfReviewStatus = data.countOfReviewStatus;
      this.countOfManagerApprovalStatus = data.countOfManagerApprovalStatus;
    });
  }

  // getEmployeeMasterCount() {
  //   var id;
  //   if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
  //     || this.loggedInUserRole == 'HR Admin') {
  //     id = this.loggedInCompanyHRID;
  //   } else {
  //     id = this.loggedInUserId
  //   }
  //   let request = {}
  //   if (id === 'null') {
  //     request = {
  //       "companyId": this.loggedInUserCompanyID,
  //       "month": this.fromDate,
  //       "userId": null,
  //       "year": this.FiscalYear,
  //       "loggedInUserRole": this.loggedInUserRole
  //     };
  //   } else {
  //     request = {
  //       "companyId": this.loggedInUserCompanyID,
  //       "month": this.fromDate,
  //       "userId": id,
  //       "year": this.FiscalYear,
  //       "loggedInUserRole": this.loggedInUserRole
  //     };
  //   }

  //   this.httpService.callPostService(this.config.getEmpMasterCount, request).subscribe((data: any) => {
  //     this.countOfActiveEmployee = this.extractBeforeSlash(data.countOfActiveEmployee);
  //     this.countOfExitedEmployee = this.extractBeforeSlash(data.countOfExitedEmployee);
  //   })
  // }
  // getDashboardCountV1() {
  //   console.log(this.loggedInCompanyMDID);
  //   console.log(this.loggedInUserId);

  //   const id =
  //     ['Super Admin', 'PHI Admin', 'HR Admin'].includes(this.loggedInUserRole)
  //       ? this.loggedInCompanyMDID
  //       : this.loggedInUserId;

  //   const request = {
  //     companyId: this.loggedInUserCompanyID,
  //     month: this.fromDate,
  //     userId: id,
  //     year: this.FiscalYear,
  //     loggedInUserRole: this.loggedInUserRole
  //   };

  //   console.log('DashboardCountV1 Payload:', request); // <— debug check

  //   this.httpService.callPostService(this.config.getDashboardCountV1, request)
  //     .subscribe((res: any) => {
  //       const data = res.data;
  //       this.countOfGoalSetting = data.goalSetting?.countOfGoalSetting;
  //       this.countOfReviewStatus = data.goalSetting?.countOfReviewStatus;
  //       this.countOfManagerApprovalStatus = data.goalSetting?.countOfManagerApprovalStatus;
  //       this.activeNo = data.employeeCount?.activeNo;
  //       this.exitedNo = data.employeeCount?.exitedNo;
  //     });
  // }
  onCheckPendingSetupsAndEmpDetails() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear,
      loggedInUserRole: this.loggedInUserRole,
      date: this.datePipe.transform(this.howAreYouFellingTodayDate, 'yyyy-MM-dd'),
      userId: this.loggedInUserId || null
    };

    this.httpService.callPostService(this.config.getSetupEmpAndMoodDetailsV2, request).subscribe((result: any) => {
      if (!result?.status) return;

      const { setupStatus = {}, empDetails = {}, userMood = {} } = result.data;

      // ---------- Handle Setup Status ----------
      const resultData = [
        { componentName: 'PMS', componentKey: 'isPmsSet', setupCompleted: false, isRegistered: false },
        { componentName: 'ELCM', componentKey: 'isElcmSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Competency', componentKey: 'isCompetencySet', setupCompleted: false, isRegistered: false },
        { componentName: 'Increment', componentKey: 'isIncrementSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Variable Pay', componentKey: 'isVPSet', setupCompleted: false, isRegistered: false },
        { componentName: '360 Degree', componentKey: 'is360DegreeSet', setupCompleted: false, isRegistered: false },
        { componentName: 'ESS', componentKey: 'isEssSet', setupCompleted: false, isRegistered: false },
        { componentName: '9 Box', componentKey: 'is9BoxSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Asset', componentKey: 'isAssetSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Expense', componentKey: 'isExpenseSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Attrition', componentKey: 'isAttritionSet', setupCompleted: false, isRegistered: false }
      ];

      const even: any[] = [];
      const odd: any[] = [];

      resultData.forEach((setup, index) => {
        if (setup.componentKey in setupStatus) {
          setup.setupCompleted = setupStatus[setup.componentKey];
          setup.isRegistered = true;
        }
        (index % 2 === 0 ? even : odd).push(setup);
      });

      this.pendingSetups = [even, odd];
      this.isIncrementSetupDone = setupStatus.isIncrementSet;
      this.isVPSetupDone = setupStatus.isVPSet;

      // ---------- Handle Employee Details ----------
      this.getEmployeeByIdData = empDetails;

      // ---------- Handle Mood Data ----------
      this.getUserExcellentFelling = userMood.excellent || 0;
      this.getUserGreatFelling = userMood.great || 0;
      this.getUserOkayFelling = userMood.okay || 0;
      this.getUserNotGreatFelling = userMood.notGreat || 0;

      if (this.getUserExcellentFelling > 0) {
        this.selectedMood = 'Excellent';
      } else if (this.getUserGreatFelling > 0) {
        this.selectedMood = 'Great';
      } else if (this.getUserOkayFelling > 0) {
        this.selectedMood = 'Okay';
      } else if (this.getUserNotGreatFelling > 0) {
        this.selectedMood = 'Not_Great';
      } else {
        this.selectedMood = null;
      }

      // ---------- Continue dependent functions ----------
      // this.getIncrementCounterList();
      this.getMergedDashboardCounters();
      // this.getVariablePayFrequency();
    });
  }

  extractBeforeSlash(value: any): any {
    return value.split('/')[0];
  }

  // Social Feed

  onClickAddNewSocialFieldPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(HomeAddNewSocialFieldPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAnnouncementAndSocialFeedData();
    });
  }

  instagramIcon: any;
  fbIcon: any;
  // getSocialFeedInfo() {
  //   this.httpService.callGetService(this.config.getSocialFeedByCompanyId + this.loggedInUserCompanyID).subscribe((result: any) => {
  //     this.socialFeedCardData = result?.data?.map((ele: any) => ({
  //       id: ele.id,
  //       feedName: ele.name,
  //       remarks: ele.remarks,
  //       feedURL: ele.url,
  //       feedType: ele.type
  //     }))
  //     this.socialFeedCount = this.socialFeedCardData?.length;
  //     const feedType = this.socialFeedCardData?.map((ele: any) => ele.type)
  //   })
  // }

  getIconByType(type: string): string {
    switch (type) {
      case 'Twitter':
        return './assets/icon/TwitterIcon.png';
      case 'Fb':
        return './assets/icon/FacebookIcon.svg';
      case 'Youtube':
        return './assets/icon/youtubeIcon.png';
      case 'Instagram':
        return './assets/icon/InstagramIcon.svg';
      case 'External_Link':
        return './assets/icon/linkIcon.png';
      default:
        return './assets/icon/DefaultIcon.svg';
    }
  }

  onClickEditNewSocialFieldPopup(id: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = this.socialFeedCardData[id];
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(HomeAddNewSocialFieldPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAnnouncementAndSocialFeedData();
    });
  }

  onClickDeleteNewSocialFieldPopup(id: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'Are you sure you want to delete?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.httpService.callGetService(this.config.deleteSocialFeed + id).subscribe((result: any) => {
          if (result) {
            this.getAnnouncementAndSocialFeedData();
          }
        });
      }
    });
  }

  onClickViewDetails(event: any) {
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.height = '100vh';
    // dialogConfig.width = '100vw';
    // dialogConfig.maxWidth = '100vw';
    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'full-screen-dialog';

    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };

    const dialogRef = this.dialog.open(ViewemployeedetailsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(_result => {
      // handle result if needed
    });
  }

  onClickOpenFeedURL(url: string) {
    if (url && url.startsWith('http')) {
      window.open(url, '_blank');
    }
  }

  // Career/ Professional Information

  showContent(tab: string) {
    this.selectedTab = tab;
  }

  getCareerProfessionalSearchData(data: any) {
    var search = '';
    this.CareerProfessionalInfoSearch = data;
    if (data == '') {
      this.CareerProfessionalInfoSearch = null;
      this.getEmployeeById();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getEmployeeById();
          }, 500);
        }
      }, 1500);
    }
  }

  // getEmployeeById(){
  //   this.httpService.callGetService(this.config.getEmployeeById + this.loggedInUserId).subscribe((result:any)=>{
  //     this.getEmployeeByIdData = result.data;
  //   })
  // }

  getEmployeeById() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear,
      userId: this.loggedInUserId || null
    };
    console.log(this.loggedInUserId);

    this.httpService.callPostService(this.config.getEmpDetailsById, request).subscribe((result: any) => {
      this.getEmployeeByIdData = result.data;
    });
  }

  // Quick Search

  onClickQuickSearchPopup(status: 'Active Employee' | 'helpDesk' | 'hrHandBook') {
    if (status == 'Active Employee') {
      const date = new Date();
      const currentMonth = date.getMonth();
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const current = monthNames[currentMonth];
      const next = monthNames[(currentMonth + 1) % 12];
      const monthRange = `${current}-${next}`;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.height = '70%';
      dialogConfig.width = '100%';
      dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
      // dialogConfig.data = { employeeStatus: status};
      dialogConfig.data = {
        currentTabName: this.currentTabName,
        btn2: 'OK',
        moduleName: status,
        popupName: 'Quarterly Vs YTD',
        month: this.fromDate,
        year: this.FiscalYear,
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      };
      dialogConfig.panelClass = 'custom-dialog-container';
      const dialogRef = this.dialog.open(DashboardDetailsPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {});
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.height = '70%';
      dialogConfig.width = '100%';
      dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
      dialogConfig.data = { statusCheck: status };
      dialogConfig.panelClass = 'custom-dialog-container';
      const dialogRef = this.dialog.open(HomeQuickSearchPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {});
    }
  }

  // Pending Setups
  onCheckPendingSetups() {
    const request = { companyId: this.loggedInUserCompanyID, fromYear: this.fromYear, toYear: this.toYear };

    this.httpService.callPostService(this.config.getSetupStatus, request).subscribe((result: any) => {
      const resultData = [
        { componentName: 'PMS', componentKey: 'isPmsSet', setupCompleted: false, isRegistered: false },
        { componentName: 'ELCM', componentKey: 'isElcmSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Competency', componentKey: 'isCompetencySet', setupCompleted: false, isRegistered: false },
        { componentName: 'Increment', componentKey: 'isIncrementSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Variable Pay', componentKey: 'isVPSet', setupCompleted: false, isRegistered: false },
        { componentName: '360 Degree', componentKey: 'is360DegreeSet', setupCompleted: false, isRegistered: false },
        { componentName: 'ESS', componentKey: 'isEssSet', setupCompleted: false, isRegistered: false },
        { componentName: '9 Box', componentKey: 'is9BoxSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Asset', componentKey: 'isAssetSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Expense', componentKey: 'isExpenseSet', setupCompleted: false, isRegistered: false },
        { componentName: 'Attrition', componentKey: 'isAttritionSet', setupCompleted: false, isRegistered: false }
      ];
      let odd: any = [],
        even: any = [];

      resultData.map((setup: any, index) => {
        if (setup.componentKey in result.data) {
          setup.setupCompleted = result.data[setup.componentKey];
          setup.isRegistered = true;
        }
        if (index % 2 === 0) {
          even.push(setup);
        } else {
          odd.push(setup);
        }
      });

      this.pendingSetups = [even, odd];

      this.isIncrementSetupDone = result.data.isIncrementSet;
      this.isVPSetupDone = result.data.isVPSet;

      // this.getIncrementCounterList();
      this.getMergedDashboardCounters();
      // this.getVariablePayFrequency()
    });
  }

  // Task Management
  taskAssignedToMeCount: any;
  taskAssignedByMeCount: any;
  DWMAssignedToMeCount: any;
  DWMAssignedByMeCount: any;

  getTaskManagementCount() {
    // if(this.selecttaskManagementTab === 'Review Meeting'){
    //   const taskStatusList = [
    //     { id: "NotStarted", name: 'Not Started' },
    //     { id: "Completed", name: 'Completed' },
    //     { id: "PartiallyCompleted", name: 'Partially Completed' },
    //     { id: "IncompleteAndEXPD", name: 'Incomplete & EXPD' }
    //   ];
    //   const request = {
    //     "companyId":this.loggedInUserCompanyID,
    //     "employeeId":[],
    //     "fromDate":this.datePipe.transform(this.taskAssignedToMeFromDate, 'yyyy-MM-dd'),
    //     "search":null,
    //     "taskStatus":taskStatusList.map((ele: { id: any; }) => ele.id),
    //     "toDate":this.datePipe.transform(this.taskAssignedToMeToDate, 'yyyy-MM-dd'),
    //     "userType":null}
    //   this.httpService.callPostService(this.config.getCountOfTasksForLandingPage, request).subscribe((data: any) => {
    //     this.taskAssignedToMeCount = data?.myTaskCount;
    //     this.taskAssignedByMeCount = data?.myTaskCount;
    //   })
    // }else{
    //   const request = {
    //     "companyId":this.loggedInUserCompanyID,
    //     "dwmStatus":["Completed","InCompleted"],
    //     "employeeId":[],
    //     "search":null,
    //     "toDate":this.datePipe.transform(this.dailyWorkManagementDate, 'yyyy-MM-dd'),
    //     "userType":null
    //   }
    //   this.httpService.callPostService(this.config.getCountOfWorkForLandingPage, request).subscribe((data: any) => {
    //     this.DWMAssignedToMeCount = data?.myTaskCount;
    //     this.DWMAssignedByMeCount = data?.myTaskCount;
    //   })
    // }
  }

  taskManagementContent(tab: any) {
    this.selecttaskManagementTab = tab;
    if (this.selecttaskManagementTab === 'Review Meeting') {
      const taskStatusList = [
        { id: 'NotStarted', name: 'Not Started' },
        { id: 'Completed', name: 'Completed' },
        { id: 'PartiallyCompleted', name: 'Partially Completed' },
        { id: 'IncompleteAndEXPD', name: 'Incomplete & EXPD' }
      ];
      const request = {
        companyId: this.loggedInUserCompanyID,
        employeeId: [this.loggedInUserId],
        fromDate: this.datePipe.transform(this.taskAssignedToMeFromDate, 'yyyy-MM-dd'),
        search: null,
        taskStatus: taskStatusList.map((ele: { id: any }) => ele.id),
        toDate: this.datePipe.transform(this.taskAssignedToMeToDate, 'yyyy-MM-dd'),
        userType: null
      };
      this.httpService.callPostService(this.config.getCountOfTasks, request).subscribe((data: any) => {
        this.taskAssignedToMeCount = data?.myTaskCount;
        this.taskAssignedByMeCount = data?.assignedTaskCount;
      });
    } else {
      const request = {
        companyId: this.loggedInUserCompanyID,
        dwmStatus: ['Completed', 'InCompleted'],
        employeeId: [],
        search: null,
        toDate: this.datePipe.transform(this.dailyWorkManagementDate, 'yyyy-MM-dd'),
        userType: null
      };
      this.httpService.callPostService(this.config.getCountOfWorkForLandingPage, request).subscribe((data: any) => {
        this.DWMAssignedToMeCount = data?.myworkCount;
        this.DWMAssignedByMeCount = data?.assignedMyWorkCount;
      });
    }
  }

  onDateChangetaskAssignedToMe() {
    this.taskManagementContent(this.selecttaskManagementTab);
  }

  onClickSwitchToReviewMeetingMyTask() {
    // if (window.innerWidth <= 800) {return;}
    this.router.navigate([
      '/home/hrportal/taskmanagements',
      {
        tab: 'Review Meeting',
        subTab: 'My Task',
        index: 0,
        formDate: this.datePipe.transform(this.taskAssignedToMeFromDate, 'yyyy-MM-dd'),
        toDate: this.datePipe.transform(this.taskAssignedToMeToDate, 'yyyy-MM-dd')
      }
    ]);
  }

  onClickSwitchToReviewMeetingAssignTask() {
    // if (window.innerWidth <= 800) {return;}
    this.router.navigate([
      '/home/hrportal/taskmanagements',
      {
        tab: 'Review Meeting',
        subTab: 'Assign a Task',
        index: 0,
        formDate: this.datePipe.transform(this.taskAssignedToMeFromDate, 'yyyy-MM-dd'),
        toDate: this.datePipe.transform(this.taskAssignedToMeToDate, 'yyyy-MM-dd')
      }
    ]);
  }

  onClickSwitchToDWMMyTask() {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    this.router.navigate([
      '/home/hrportal/taskmanagements',
      {
        tab: 'Daily Work Management',
        subTab: 'My DWM',
        index: 1,
        currentDate: this.datePipe.transform(this.dailyWorkManagementDate, 'yyyy-MM-dd')
      }
    ]);
  }

  onClickSwitchToDWMTeamDWM() {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    this.router.navigate([
      '/home/hrportal/taskmanagements',
      {
        tab: 'Daily Work Management',
        subTab: 'Team DWM',
        index: 1,
        currentDate: this.datePipe.transform(this.dailyWorkManagementDate, 'yyyy-MM-dd')
      }
    ]);
  }

  // Organisation Announcement

  // How are you feeling today?
  selectedMood: string | null = null;
  isMoodSelectionDisabled: boolean = false;
  setUserHowAreYourFellingToday(moodData: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      date: this.datePipe.transform(this.howAreYouFellingTodayDate, 'yyyy-MM-dd'),
      id: null,
      mood: moodData,
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.setUserMood, request).subscribe(result => {
      if (result) {
        this.getHowAreYouFellingTodayData();
      }
    });
  }

  setHowAreYouFellingTodayDate() {
    if (this.howAreYouFellingTodayDate) {
      const selectedDate = new Date(this.howAreYouFellingTodayDate);
      const currentDate = new Date();

      // Reset time portion to compare only the dates
      selectedDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      if (selectedDate < currentDate) {
        this.isMoodSelectionDisabled = true;
        this.selectedMood = null;
        this.getHowAreYouFellingTodayData();
      } else {
        this.isMoodSelectionDisabled = false;
        this.getHowAreYouFellingTodayData();
      }
    }
  }

  getHowAreYouFellingTodayData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      date: this.datePipe.transform(this.howAreYouFellingTodayDate, 'yyyy-MM-dd'),
      loggedInUserRole: this.loggedInUserRole,
      userId: this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getUserMood, request).subscribe((result: any) => {
      if (result?.status) {
        this.getUserExcellentFelling = result.data.excellent;
        this.getUserGreatFelling = result.data.great;
        this.getUserOkayFelling = result.data.okay;
        this.getUserNotGreatFelling = result.data.notGreat;

        if (this.getUserExcellentFelling > 0) {
          this.selectedMood = 'Excellent';
        } else if (this.getUserGreatFelling > 0) {
          this.selectedMood = 'Great';
        } else if (this.getUserOkayFelling > 0) {
          this.selectedMood = 'Okay';
        } else if (this.getUserNotGreatFelling > 0) {
          this.selectedMood = 'Not_Great';
        } else {
          this.selectedMood = null;
        }
      }
    });
  }
  // Competency

  competenciesSet: string = '';
  evaluatedCompetencies: string = '';

  onClickCompetencySetStatusPopup(popupName: any) {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    if (!this.isCompetencyModuleAvailable) return;
    if (popupName == 'Competency Score' || popupName == 'Competency Rating') {
      this.router.navigate(['/home/hrportal/competency', { tab: 'My Competency' }]);
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.height = '70%';
      dialogConfig.width = '100%';
      dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
      dialogConfig.data = {
        btn2: 'OK',
        popupName: popupName,
        year: this.FiscalYear,
        setupGradeBrand: this.setupGradeBrand || null
      };
      dialogConfig.panelClass = 'custom-dialog-container';
      const dialogRef = this.dialog.open(CompetecnyDashboardDetailsPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {});
    }
  }

  getGlobalSummary() {
    const Request = {
      companyId: this.loggedInUserCompanyID,
      loggedInUserRole: this.loggedInUserRole,
      employeeId: null,
      managerCode: null,
      topOrBottom: null,
      yearRange: this.FiscalYear
    };

    this.httpService.callPostService(this.config.getGlobalSummaryDashboard, Request).subscribe(
      (response: any) => {
        if (response && response.status) {
          this.competenciesSet = response.data.competenciesSet;
          this.evaluatedCompetencies = response.data.evaluatedCompetencies;
          console.log('Getting landing page data....', this.evaluatedCompetencies);
        }
      },
      error => {}
    );
  }

  scoreForDashboard: any;
  competencyRatingDashboard: any;

  // getEmployeeUnderManager() {
  //   this.httpService.callGetService(this.config.competencyEmployeeUnderManager + this.loggedInUserId + "/" + this.FiscalYear)
  //     .subscribe((data: any) => {
  //       this.employeelistUnderManager = (data?.data || []).map((employee: any) => ({
  //         id: employee.id,
  //         fullName: `${employee.firstName} ${employee.lastName}`.trim()
  //       }));
  //       this.employeelistUnderManager = this.employeelistUnderManager?.sort((a: { fullName: any; }, b: { fullName: any; }) => a.fullName.localeCompare(b.fullName));
  //       if (this.employeelistUnderManager.length != 0) {
  //         this.selectedEmployeeDashboardId = this.employeelistUnderManager[0].id;
  //         if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
  //           this.selectedEmployeeDashboardId = this.loggedInUserId;
  //         }
  //         this.getEmployeeScoreAndRating();
  //       }
  //     });
  // }
  getManagerDashboardData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    };

    this.httpService.callPostService(`${this.config.getManagerDashboardDatav2}/${this.loggedInUserId}`, request).subscribe((data: any) => {
      if (!data?.status) return;

      const { months, reviewCycle, employeesUnderManager } = data.data || {};

      // ====== MONTHS HANDLING ======
      this.getMonthsByFiscalandReviewCycle = months || [];
      this.getMonthsByFiscalandReviewCycleForReport = this.getMonthsByFiscalandReviewCycle.map((ele: any) => ({
        id: ele,
        name: this.sharedService.transform(ele)
      }));

      this.selectedYearReviewCycle = reviewCycle;
      this.selectedReviewCycle = [];

      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const currentMonth = today.toLocaleString('default', { month: 'long' });

      if (reviewCycle === 'Monthly') {
        this.getMonthsByFiscalandReviewCycle.forEach((ele: any) => {
          const [month] = ele?.split('-');
          if (month === currentMonth) {
            this.fromDate = this.toDate = ele;
            this.selectedReviewCycle.push({ id: ele, name: this.sharedService.transform(ele) });
          }
        });
      } else if (['Quarterly', 'Semi_Annually', 'Annually'].includes(reviewCycle)) {
        for (let range of this.getMonthsByFiscalandReviewCycle) {
          const [start, end] = range.split('-');
          const startIndex = this.getMonthIndex(start);
          const endIndex = this.getMonthIndex(end);

          const withinRange = (currentMonthIndex >= startIndex && currentMonthIndex <= endIndex) || (startIndex > endIndex && (currentMonthIndex >= startIndex || currentMonthIndex <= endIndex));

          if (withinRange) {
            this.fromDate = this.toDate = range;
            this.selectedReviewCycle.push({ id: range, name: this.sharedService.transform(range) });
          }
        }
      }

      // ====== EMPLOYEE UNDER MANAGER ======
      this.employeelistUnderManager = (employeesUnderManager || [])
        .map((emp: any) => ({
          id: emp.id,
          fullName: `${emp.firstName} ${emp.lastName}`.trim()
        }))
        .sort((a: any, b: any) => a.fullName.localeCompare(b.fullName));

      // Preselect manager or first employee
      if (this.employeelistUnderManager.length) {
        this.selectedEmployeeDashboardId = this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD' ? this.loggedInUserId : this.employeelistUnderManager[0].id;

        this.getEmployeeScoreAndRating();
      }

      // ====== Dependent Calls ======
      // this.getDashboardCountV1();
      this.getDashboardCount();
    });
  }

  getEmployeeScoreAndRating() {
    const Request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeDashboardId,
      managerCode: null,
      yearRange: this.FiscalYear
    };

    this.httpService.callPostService(this.config.getEmployeeRatingAndScoreDashboard, Request).subscribe((response: any) => {
      if (response && response.status) {
        this.scoreForDashboard = response.data.score;
        this.competencyRatingDashboard = response.data.competencRating;
      }
    });
  }

  // Welcome New Employee
  // showNewEmpContent(tab: string) {
  //   this.selectedNewEmpTab = tab
  //   if (this.selectedNewEmpTab == 'PreviousMonthTab') {
  //     this.showNewEmployeePreviousMonthData();
  //   } else if (this.selectedNewEmpTab == 'CurrentMonthTab') {
  //     this.showNewEmployeeCurrentMonthData();
  //   } else { }
  // }

  // showNewEmployeeCurrentMonthData() {
  //   const today = new Date();
  //   const formattedDate = this.datePipe.transform(today, 'yyyy-MM-dd') || '';
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //     //  "date": "2024-07-01"
  //   }
  //   this.httpService.callPostService(this.config.getNewEmployeeByDateAndCompany, request).subscribe((result: any) => {
  //     this.getAddNewEmployeeData = result.data.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,

  //     }));
  //     this.getAddNewEmployeeTotalEmp = this.getAddNewEmployeeData.length;
  //   })
  // }

  // showNewEmployeePreviousMonthData() {
  //   const yesterday = new Date();
  //   yesterday.setMonth(yesterday.getMonth() - 1);
  //   const formattedDate = this.datePipe.transform(yesterday, 'yyyy-MM-dd') || '';
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //     // "date": "2024-07-01"
  //   }
  //   this.httpService.callPostService(this.config.getNewEmployeeByDateAndCompany, request).subscribe((result: any) => {
  //     this.getAddNewEmployeeData = result.data.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,
  //     }));
  //     this.getAddNewEmployeeTotalEmp = this.getAddNewEmployeeData.length;
  //   })
  // }

  onClickSendMailNewEmployeePopup(employeeList: any, popupName: any) {
    // let employeeList:any = [];
    // if(popupName == 'welcome'){
    //   employeeList = this.getAddNewEmployeeData;
    // }else if(popupName == 'birthday'){
    //   if(this.selectedBMACelebrationTab == 'yesterDay'){
    //     employeeList = this.getBirthdaysAndAnniversariesYesterDayData
    //   }else if(this.selectedBMACelebrationTab == 'toDay'){
    //     employeeList = this.getBirthdaysAndAnniversariesToDayData
    //   }else if(this.selectedBMACelebrationTab == 'nextDay'){
    //     employeeList = this.getBirthdaysAndAnniversariesNextDayData
    //   }
    // }else if(popupName == 'work anniversary'){
    //   if(this.selectedWACelebrationTab == 'Yesterday'){
    //     employeeList = this.getWorkAnniversariesByYesterdayDateData
    //   }
    //   if(this.selectedWACelebrationTab == 'Today'){
    //     employeeList = this.getWorkAnniversariesByToDayDateData
    //   }
    //   if(this.selectedWACelebrationTab == 'Tommorrow'){
    //     employeeList = this.getWorkAnniversariesByTommorrowDateData
    //   }
    // }

    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '70%';
    // dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      employeeList: employeeList,
      popupName: popupName
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(HomeWelcomeNewEmployeePopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});
  }

  // Increments & variable pay
  getIncrementCounterList() {
    let request = {};
    if (this.loggedInUserRole == 'HOD') {
      request = {
        companyId: this.loggedInUserCompanyID,
        depts: null,
        fromYear: this.fromYear,
        isHod: true,
        toYear: this.toYear
      };
    } else {
      request = {
        companyId: this.loggedInUserCompanyID,
        depts: null,
        fromYear: this.fromYear,
        isHod: false,
        toYear: this.toYear
      };
    }
    this.httpService.callPostService(this.config.getCounters, request).subscribe((result: any) => {
      if (this.isIncrementSetupDone == true) {
        this.incrementBudgetPercentage = result.data.budgetPercentage;
        this.incrementBudgetAmount = result.data.budgetAmount;
      }
    });
  }

  onClickredirectToIncrement() {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    if (this.isIncrementModuleAvailable) {
      this.router.navigate(['/home/hrportal/increment']);
    }
  }

  vpFrequencyMonth: any;
  getVariablePayFrequency() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      if (this.isVPSetupDone == true) {
        this.vpFrequency = response.data;
        if (this.vpFrequency && this.vpFrequency.length > 0) {
          this.vpFrequencyMonth = this.vpFrequency[this.vpFrequency.length - 1];
          // this.getVPBudgetCount(this.vpFrequency[this.vpFrequency.length - 1]);
          // this.getMergedDashboardCounters();
        }
      }
    });
  }

  getVPBudgetCount(frequencyCycle: any) {
    const payload = {
      companyId: this.loggedInUserCompanyID,
      depts: null,
      frequency: null,
      frequencyCycle: frequencyCycle,
      fromYear: Number(this.fromYear),
      toYear: Number(this.toYear),
      isHod: this.loggedInUserRole == 'HOD'
    };
    this.httpService.callPostService(this.config.variableDashboardCount, payload).subscribe((result: any) => {
      this.vpBudgetPercentage = parseFloat(result.data.budgetPercentage).toFixed(2) + ' %';
      const budgetAmount = parseFloat(result.data.budgetAmount);
      this.vpBudgetAmount = isNaN(budgetAmount) ? result.data.budgetAmount : budgetAmount.toFixed(2) + 'L';
    });
  }
  getMergedDashboardCounters(): void {
    const payload = {
      companyId: this.loggedInUserCompanyID,
      depts: null,
      frequency: null,
      fromYear: Number(this.fromYear),
      toYear: Number(this.toYear),
      isHod: this.loggedInUserRole === 'HOD'
    };

    this.httpService.callPostService(this.config.mergedCounters, payload).subscribe({
      next: (result: any) => {
        if (!result?.data) return;

        const incrementData = result.data.INCREMENT;
        const variablePayData = result.data.VARIABLE_PAY;

        const frequencies = result.data.frequencies;

        // --- INCREMENT ---
        if (incrementData && this.isIncrementSetupDone) {
          this.incrementBudgetPercentage = incrementData.budgetPercentage;
          this.incrementBudgetAmount = incrementData.budgetAmount;
        }

        // --- VARIABLE PAY ---
        if (variablePayData) {
          this.vpBudgetPercentage = variablePayData.budgetPercentage;
          this.vpBudgetAmount = variablePayData.budgetAmount;
        }
        // --- FREQUENCY INFO (from merged response) ---
        if (frequencies) {
          this.vpFrequencyMonth = frequencies;
        }
      },
      error: err => {
        console.error('Error fetching merged counters:', err);
      }
    });
  }

  onClickredirectToVP() {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    if (this.isVariablePayModuleAvailable) {
      this.router.navigate(['/home/hrportal/variablepay']);
    }
  }
  // Birthdays/ Marriage Anniversaries

  // showBMAcelebrationContent(tab: string) {
  //   this.selectedBMACelebrationTab = tab
  //   if (this.selectedBMACelebrationTab == 'yesterDay') {
  //     this.getBirthDayAndAnniversariesByYesterdayDate()
  //   } else if (this.selectedBMACelebrationTab == 'toDay') {
  //     this.getBirthDayAndAnniversariesBytoDayDate();
  //   } else if (this.selectedBMACelebrationTab == 'nextDay') {
  //     this.getBirthDayAndAnniversariesByNextdayDate()
  //   } else { }
  // }

  // getBirthDayAndAnniversariesByYesterdayDate() {
  //   const yesterday = new Date();
  //   yesterday.setDate(yesterday.getDate() - 1);
  //   const formattedDate = this.datePipe.transform(yesterday, 'yyyy-MM-dd') || '';

  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //   }
  //   this.httpService.callPostService(this.config.getBirthdaysAndAnniversariesByDateAndCompany, request).subscribe((result: any) => {
  //     this.getBirthdaysAndAnniversariesYesterDayData = result.data.birthdays.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,
  //     }));
  //     this.BirthdaysMarriageAnniversariesTotalEmp = this.getBirthdaysAndAnniversariesYesterDayData.length;
  //   })
  // }

  // getBirthDayAndAnniversariesBytoDayDate() {
  //   const today = new Date();
  //   const formattedDate = this.datePipe.transform(today, 'yyyy-MM-dd') || '';

  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //   }
  //   this.httpService.callPostService(this.config.getBirthdaysAndAnniversariesByDateAndCompany, request).subscribe((result: any) => {
  //     this.getBirthdaysAndAnniversariesToDayData = result.data.birthdays.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,
  //     }));
  //     this.BirthdaysMarriageAnniversariesTotalEmp = this.getBirthdaysAndAnniversariesToDayData.length;
  //   })
  // }

  // getBirthDayAndAnniversariesByNextdayDate() {
  //   const nextDay = new Date();
  //   nextDay.setDate(nextDay.getDate() + 1);
  //   const formattedDate = this.datePipe.transform(nextDay, 'yyyy-MM-dd') || '';

  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //   }
  //   this.httpService.callPostService(this.config.getBirthdaysAndAnniversariesByDateAndCompany, request).subscribe((result: any) => {
  //     this.getBirthdaysAndAnniversariesNextDayData = result.data.birthdays.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,
  //     }));
  //     this.BirthdaysMarriageAnniversariesTotalEmp = this.getBirthdaysAndAnniversariesNextDayData.length;

  //   })
  // }

  // // Work Anniversaries

  // showWAcelebrationContent(tab: string) {
  //   this.selectedWACelebrationTab = tab

  //   if (this.selectedWACelebrationTab == 'Yesterday') {
  //     this.getWorkAnniversariesByYesterdayDate();
  //   } else if (this.selectedWACelebrationTab == 'Today') {
  //     this.getWorkAnniversariesByTodayDate();
  //   } else if (this.selectedWACelebrationTab == 'Tommorrow') {
  //     this.getWorkAnniversariesByTommorrowdayDate();
  //   } else { }
  // }

  // getWorkAnniversariesByYesterdayDate() {
  //   const nextDay = new Date();
  //   nextDay.setDate(nextDay.getDate() - 1);
  //   const formattedDate = this.datePipe.transform(nextDay, 'yyyy-MM-dd') || '';
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //   }
  //   this.httpService.callPostService(this.config.getWorkAnniversaryByDateAndCompany, request).subscribe((result: any) => {
  //     this.getWorkAnniversariesByYesterdayDateData = result.data?.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,
  //     }));
  //     this.WorkAnniversariesTotalEmp = this.getWorkAnniversariesByYesterdayDateData?.length;
  //   })
  // }

  // getWorkAnniversariesByTodayDate() {
  //   const today = new Date();
  //   const formattedDate = this.datePipe.transform(today, 'yyyy-MM-dd') || '';
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //   }
  //   this.httpService.callPostService(this.config.getWorkAnniversaryByDateAndCompany, request).subscribe((result: any) => {
  //     this.getWorkAnniversariesByToDayDateData = result.data?.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,
  //     }));
  //     this.WorkAnniversariesTotalEmp = this.getWorkAnniversariesByToDayDateData?.length;
  //   })
  // }

  // getWorkAnniversariesByTommorrowdayDate() {
  //   const nextDay = new Date();
  //   nextDay.setDate(nextDay.getDate() + 1);
  //   const formattedDate = this.datePipe.transform(nextDay, 'yyyy-MM-dd') || '';
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": formattedDate
  //   }
  //   this.httpService.callPostService(this.config.getWorkAnniversaryByDateAndCompany, request).subscribe((result: any) => {
  //     this.getWorkAnniversariesByTommorrowDateData = result.data?.map((ele: any) => ({
  //       name: `${ele.firstName} ${ele.lastName}`,
  //       designation: ele.designation,
  //       contactNo: ele.contactNo,
  //       officialEmail: ele.officialEmail,
  //       id: ele.id,
  //     }));
  //     this.WorkAnniversariesTotalEmp = this.getWorkAnniversariesByTommorrowDateData?.length;
  //   })
  // }
  // new birthdays/ work anniversary/ work anniversary/ employee
  // -------------------- DATA MODELS --------------------
  birthdaysData = { yesterday: [], today: [], tomorrow: [] as Employee[][] } as any;
  workAnniversariesData = { yesterday: [], today: [], tomorrow: [] as Employee[][] } as any;
  newEmployeeData = { yesterday: [], today: [], tomorrow: [] as Employee[][] } as any;

  BirthdaysMarriageAnniversariesTotalEmp = 0;
  WorkAnniversariesTotalEmp = 0;
  NewEmployeesTotalEmp = 0;

  private cachedWishesData: Record<string, any> = {}; // cache per date key

  // -------------------- MAIN FUNCTION --------------------
  private getAllWishesByDate(offsetDays: number): void {
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + offsetDays);
    const formattedDate = this.datePipe.transform(targetDate, 'yyyy-MM-dd')!;
    const cacheKey = formattedDate;

    // ✅ Use cache to avoid multiple API calls
    if (this.cachedWishesData[cacheKey]) {
      this.assignData(this.cachedWishesData[cacheKey], offsetDays);
      return;
    }

    const request = {
      companyId: this.loggedInUserCompanyID,
      date: formattedDate
    };

    console.log('🔵 Fetching data for date:', formattedDate);

    this.httpService.callPostService(this.config.getAllWishesByDateAndCompanyV2, request).subscribe({
      next: (result: any) => {
        const data = result?.data || {};
        this.cachedWishesData[cacheKey] = data;
        this.assignData(data, offsetDays);
      },
      error: err => console.error('❌ getAllWishesByDate error:', err)
    });
  }

  // -------------------- HELPER --------------------
  private assignData(data: any, offsetDays: number) {
    const dayKey = offsetDays === -1 ? 'yesterday' : offsetDays === 1 ? 'tomorrow' : 'today';

    this.birthdaysData[dayKey] = this.mapEmployeeData(data.birthdays || []);
    this.workAnniversariesData[dayKey] = this.mapEmployeeData(data.workAnniversaries || []);
    this.newEmployeeData[dayKey] = this.mapEmployeeData(data.newEmployees || []);

    this.BirthdaysMarriageAnniversariesTotalEmp = this.birthdaysData[dayKey].length;
    this.WorkAnniversariesTotalEmp = this.workAnniversariesData[dayKey].length;
    this.NewEmployeesTotalEmp = this.newEmployeeData[dayKey].length;
  }

  private mapEmployeeData(list: any[]): Employee[] {
    if (!Array.isArray(list)) return [];
    return list.map((ele: any) => ({
      id: ele.id,
      name: `${ele.firstName} ${ele.lastName}`,
      designation: ele.designation,
      contactNo: ele.contactNo,
      officialEmail: ele.officialEmail
    }));
  }

  // -------------------- TAB SWITCH --------------------
  showBMAcelebrationContent(tab: string): void {
    this.selectedBMACelebrationTab = tab;
    if (tab === 'yesterDay') this.getAllWishesByDate(-1);
    else if (tab === 'toDay') this.getAllWishesByDate(0);
    else if (tab === 'nextDay') this.getAllWishesByDate(1);
  }

  showWAcelebrationContent(tab: string): void {
    this.selectedWACelebrationTab = tab;
    if (tab === 'Yesterday') this.getAllWishesByDate(-1);
    else if (tab === 'Today') this.getAllWishesByDate(0);
    else if (tab === 'Tommorrow') this.getAllWishesByDate(1);
  }

  showNewEmpContent(tab: string): void {
    this.selectedNewEmpTab = tab;
    if (tab === 'previousDay') this.getAllWishesByDate(-1);
    else if (tab === 'toDay') this.getAllWishesByDate(0);
    else if (tab === 'nextDay') this.getAllWishesByDate(1);
  }

  // -------------------- TEMPLATE GETTERS --------------------

  // Birthdays + Anniversaries
  get getBirthdaysAndAnniversariesYesterDayData(): Employee[] {
    return this.birthdaysData.yesterday;
  }
  get getBirthdaysAndAnniversariesToDayData(): Employee[] {
    return this.birthdaysData.today;
  }
  get getBirthdaysAndAnniversariesNextDayData(): Employee[] {
    return this.birthdaysData.tomorrow;
  }

  // Work Anniversaries
  get getWorkAnniversariesByYesterdayDateData(): Employee[] {
    return this.workAnniversariesData.yesterday;
  }
  get getWorkAnniversariesByToDayDateData(): Employee[] {
    return this.workAnniversariesData.today;
  }
  get getWorkAnniversariesByTommorrowDateData(): Employee[] {
    return this.workAnniversariesData.tomorrow;
  }

  // New Employees
  get getAddNewEmployeeData(): Employee[] {
    return this.newEmployeeData.today;
  }
  get getAddNewEmployeeTotalEmp(): number {
    return this.NewEmployeesTotalEmp;
  }

  // Leave and Attendance

  showLeaveAndAttendanceContent(tab: string) {
    this.selectLeaveAndAttendanceTab = tab;
  }

  // ELCM

  // onClickEmployeeMasterPopup(status:any){
  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.height = '70%';
  //   dialogConfig.width = '100%';
  //   dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
  //   dialogConfig.data = {
  //     moduleName: status,
  //   };
  //   dialogConfig.panelClass = 'custom-dialog-container';
  //   console.warn(dialogConfig.data);

  //   const dialogRef = this.dialog.open(HomeEmployeeMasterPopupComponent, dialogConfig);
  //   dialogRef.afterClosed().subscribe(result => {
  //   });
  // }

  onClickEmployeeMasterPopup(status: any) {
    if (status != 'Employee Search') {
      return;
    }
    const date = new Date();
    const currentMonth = date.getMonth();
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const current = monthNames[currentMonth];
    const next = monthNames[(currentMonth + 1) % 12];
    const monthRange = `${current}-${next}`;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    // dialogConfig.data = { employeeStatus: status};
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: status,
      popupName: 'Quarterly Vs YTD',
      month: this.fromDate,
      year: this.FiscalYear,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    console.warn(status);

    dialogConfig.panelClass = 'custom-dialog-container';
    if (status === 'Active Employee' || status === 'Exited Employee' || status == 'Employee Search') {
      const dialogRef = this.dialog.open(HomeEmployeeMasterPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {});
    } else {
      const dialogRef = this.dialog.open(DashboardDetailsPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {});
    }
  }

  onClickCreateAnnouncementPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(HomeCreateAnnouncementPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAnnouncementAndSocialFeedData();
    });
  }
  getAnnouncementAndSocialFeedData() {
    this.httpService.callGetService(`${this.config.getAnnouncementsAndSocialFeedByCompanyId}${this.loggedInUserCompanyID}`).subscribe((result: any) => {
      if (!result?.status) return;

      const { announcements = [], socialFeeds = [] } = result.data || {};

      // ----- Handle Announcements -----
      this.getAnnouncementTableData = announcements.map((item: any) => ({
        id: item.id,
        subject: item.subject,
        updatedAt: item.updatedAt
      }));

      // ----- Handle Social Feeds -----
      this.socialFeedCardData = socialFeeds.map((ele: any) => ({
        id: ele.id,
        feedName: ele.name,
        remarks: ele.remarks,
        feedURL: ele.url,
        feedType: ele.type
      }));

      this.socialFeedCount = this.socialFeedCardData.length;
    });
  }

  // getAnnouncementData() {
  //   this.httpService.callGetService(this.config.getAnnouncementByCompanyId + this.loggedInUserCompanyID).subscribe((result: any) => {
  //     this.getAnnouncementTableData = result.data;
  //   })
  // }

  onEditAnnouncementData(id: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = this.getAnnouncementTableData[id];
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(HomeCreateAnnouncementPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAnnouncementAndSocialFeedData();
    });
  }

  // ------------------birthday ----------------------------------------------

  checkToggle(types: any) {
    let url;
    if (types == 'birthday') {
      url = `${this.config.sendWishesAccordingToToggele}/${this.loggedInUserCompanyID}?type=${types}&enable=${!this.toggleBirthdayAnniversary}`;
    } else {
      url = `${this.config.sendWishesAccordingToToggele}/${this.loggedInUserCompanyID}?type=${types}&enable=${!this.toggleAnniversary}`;
    }
    this.httpService.callPostService(url, {}).subscribe({
      next: res => {
        console.log('Toggle updated successfully:', res);
        if (types == 'birthday') {
          this.getWishes();
        } else {
          this.getWishesForWorkAnniversery();
        }
      },
      error: err => {
        console.error('Error updating toggle:', err);
      }
    });
  }

  getWishes() {
    this.httpService.callGetService(`${this.config.getWishes}/${this.loggedInUserCompanyID}?type=birthday`).subscribe((record: any) => {
      if (record) {
        this.toggleBirthdayAnniversary = record?.data;
      }
    });
  }

  getWishesForWorkAnniversery() {
    this.httpService.callGetService(`${this.config.getWishes}/${this.loggedInUserCompanyID}?type=anniversary`).subscribe((record: any) => {
      if (record) {
        this.toggleAnniversary = record?.data;
      }
    });
  }
  onClickOpenCreate(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      popupName: popupName,

      companyYear: this.FiscalYear
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ElcmCreateEmailTempletComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});
  }

  // Career/ Professional Information

  // Leave And Attendance

  currentYear: any;
  currentMonth: any;
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  calendarDates: any[] = [];

  // Sample event days
  // eventDays = [2, 4, 13, 14];
  eventDays: any = [];

  generateCalendar() {
    this.calendarDates = [];
    const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
    const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();

    // Add leading empty days for alignment
    for (let i = 1; i < firstDay; i++) {
      this.calendarDates.push({ date: '', otherMonth: true });
    }

    // Add actual dates
    for (let i = 1; i <= daysInMonth; i++) {
      this.calendarDates.push({ date: i, otherMonth: false });
    }
  }

  previousMonth() {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.generateCalendar();
  }

  nextMonth() {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar();
  }

  isToday(date: any): boolean {
    const today = new Date();
    return date.date === today.getDate() && this.currentMonth === today.getMonth() && this.currentYear === today.getFullYear();
  }

  isEventDay(date: any): boolean {
    return this.eventDays.includes(date.date);
  }

  onDateClick(date: any) {
    if (!date.otherMonth) {
      alert(`You clicked on ${date.date}`);
    }
  }

  //Recruitment
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  positions: any;
  dataSource = new MatTableDataSource<any>([]);
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  addCandidate(): void {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.height = '70%';
    config.width = '70%';
    config.panelClass = 'custom-dialog-container';
    config.data = {};

    const dialogRef = this.dialog.open(AddEditCandidatePopupComponent, config);
    dialogRef.afterClosed().subscribe(result => {});
  }
  displayedColumns: string[] = ['positionId', 'positionName', 'vacancyCount', 'actions'];
  private fetchPositions(): void {
    const url = `${this.config.IJP}?companyId=${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(url).subscribe({
      next: (res: any) => {
        this.positions = res?.filter((item: any) => !item.isDeleted) || [];
        this.dataSource.data = this.positions;
      },
      error: err => console.error('Error fetching IJP Positions:', err)
    });
  }
  openViewPositionForm(position: any): void {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.height = '70%';
    config.width = '70%';
    config.panelClass = 'custom-dialog-container';
    config.data = {
      positionRequisitionData: {
        positionReuisition: position
      },
      isViewMode: true
    };
    this.dialog.open(PositionrequisitionformComponent, config);
  }

  payloadForError!: any;
  disablePunchButtons = false;
  async markAttendance(eventTypedId: number) {
    this.payloadForError = '';
    this.disablePunchButtons = true;

    await this.latLongService
      .getLatLong()
      .then((getLatLong: any) => {
        const errorTypes = ['location disabled', 'Location permission was denied', 'Location services are not enabled', 'location unavailable']; // If required add error types in here

        if (getLatLong?.message) {
          this.disablePunchButtons = false;
          if (errorTypes.includes(getLatLong?.message.trim())) {
            if (getLatLong?.message.trim() == 'location disabled' || getLatLong?.message.trim() == 'location unavailable') {
              this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Please ensure that your GPS and internet connection are enabled.' });
            } else {
              this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: getLatLong?.message });
            }
          } else {
            this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Punch request failed. Please ensure that location permissions are enabled, and that both GPS and internet connectivity are active on your device, and you are within 50 meters of the authorized office location, then try again.' });
          }
          return;
        }

        const payload = {
          companyId: '' + this.loggedInUserCompanyID, // string → Company ID (Mandatory)
          empCode: '' + this.loggedInUserEmpCode, // string → Employee Code ( Mandatory )
          eventTypeId: +eventTypedId, // int → Punch In = 1, Punch Out = 2 ( Mandatory )
          lat: '' + getLatLong?.userLat, // string → Latitude
          lng: '' + getLatLong?.userLng, // string → Longitude

          remarks: '',
          address: '',
          fileName: ''
        };
        this.payloadForError = 'companyId: ' + this.loggedInUserCompanyID + ', empCode: ' + this.loggedInUserEmpCode + ', eventTypeId: ' + eventTypedId + ', lat: ' + getLatLong?.userLat + ', lng: ' + getLatLong?.userLng;

        this.httpService.callPostService(this.config.employeePunchInPunchOut, payload).subscribe({
          next: (value: any) => {
            this.disablePunchButtons = false;
            if (value.status) {
              this.toastr.success(value?.data);
            } else {
              this.toastr.error(value?.data);
            }
          },
          error: (error: any) => {
            const payloadErr = {
              empCode: this.loggedInUserEmpCode,
              payload: this.payloadForError,
              type: 'Api_error',
              message: error
            };
            this.toastr.error('Punch request failed. Please try again in a few moments.');
            this.disablePunchButtons = false;
            this.httpService.callPostServiceWithoutToken(this.config.employeePunchRequestFailedLog, payloadErr).subscribe();
          }
        });
      })
      .catch((error: any) => {
        const payloadErr = {
          empCode: this.loggedInUserEmpCode,
          payload: this.payloadForError,
          type: 'try_catch_error',
          message: error
        };
        this.disablePunchButtons = false;
        this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: 'Punch request failed. Please try again in a few moments.' });
        this.httpService.callPostServiceWithoutToken(this.config.employeePunchRequestFailedLog, payloadErr).subscribe();
      });
  }
}

// onEmployeeSearch(data:any){
//   var search = ''
//   this.searchEmployee = data;
//   if (data == '') {
//     this.searchEmployee = null;
//     this.getEmployeeSearch();
//     return;
//   }
//   if (data.length > 1) {
//     setTimeout(() => {
//       search = data;
//       if (search.length == data.length) {
//         setTimeout(() => {
//           this.getEmployeeSearch();
//         },
//           500);
//       }
//     },
//       1500);
//   }
// }
